class ToolboxDragAction {
    static get TYPE_CHECKPOINT(){ return 'checkpoint'; }
    static get TYPE_BRICK(){ return 'brick'; }
    
    constructor(type, data = {}) {
        this.type = type;
        this.data = data;
    }
    
    writeToEvent(event){
        //dataTransfer does not like objects; so we'll have to serialize our definition
        event.dataTransfer.setData('application/json', JSON.stringify(this));
    }
    
    static deserializeFromEvent(event){
        const serialized = event.dataTransfer.getData('application/json');
        const {type, data} = JSON.parse(serialized);
        return new ToolboxDragAction(type, data);
    }
}

export default ToolboxDragAction;